import { view, hdrm } from '@yola/ws-sdk';
import preparePaletteElement from './prepare-palette-element';
import refreshStore from '../../onlinestore/helpers/refresh-store';

const { updateStrategies } = hdrm.constants;

const updateLivePaletteElement = (compiledPalette) => {
  // Don't inject a palette to the DOM in the case when the generation of the palette didn't compile successfully
  if (!compiledPalette) return;

  const { element, compiledElement: paletteElement } = preparePaletteElement({ compiledPalette });

  if (element) {
    const targetElementId = view.accessors.getLiveElementId(element);

    view.operations.replaceElement(paletteElement, targetElementId, {
      strategy: updateStrategies.UPDATE_LIVE_ONLY,
    });
    // we need trigger store refreshing each time when palette is changed
    refreshStore();
  }
};

export default updateLivePaletteElement;
